import { render, staticRenderFns } from "./PremiumFeatureBadge.vue?vue&type=template&id=e831a198"
import script from "./PremiumFeatureBadge.vue?vue&type=script&lang=js"
export * from "./PremiumFeatureBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports